//import moment from 'moment';
import React, { memo, useState } from 'react';
import { Accordion, Card, Row } from "react-bootstrap";
//import { useDispatch } from 'react-redux';
//import { analyzeRecentSummary } from '../../actions/analyze';
import { AnalayzeRecentSummary } from './AnalyzeRecentSummary';
import { AnalyzeRecentSummaryDetail } from './AnalyzeRecentSummaryDetail';

export const SummaryYearAccordian = memo(({ year, data, index, propState }) => {
    //const dispatch = useDispatch();
    const [isOpen, setOpen] = useState(false);

    const onShowShape = (e) => {
        if (!propState.drawing) return;
        propState.drawing.setBounds(propState.regionId)
        e.stopPropagation();
    };

    /*  const onShowWorkWindow = (date) => {
         let startDate = null;
         let endDate = null;
         if (!date && data && data.length > 0) {
             startDate = data[data.length - 1].worked_day;
             endDate = data[0].worked_day;
         }
         const params = {
             replayBox:null,
             workWindow: {
                 show: true,
                 range: {
                     start_date: moment(startDate).startOf("days"),
                     end_date: moment(endDate).endOf("days")
                 }
             }
         }
         dispatch(analyzeRecentSummary(params));       
     } */

    return (
        <Accordion key={`p-accordian${index}`} className='primary-accord'>
            <Card key={index} className='summary-card' >
                <Card.Header className='summary-header'>
                    <Accordion.Toggle as={Card.Header} eventKey={String(index)} onClick={(e) => { setOpen(!isOpen); onShowShape(e) }}>
                        <Row className='m-0 align-items-center'>
                            <div className='mr-auto summary-text'>
                                {/*  <p className='mb-0 font-weight-bold summary-value-header' >{data.name}</p> */}
                                <p className='mb-0 font-weight-bold summary-value-header'>{year ? year : 'N/A'}</p>
                            </div>
                            {/* <div className='all-btn' onClick={(e) => { onShowShape(e); onShowWorkWindow(null); }}>All</div> */}
                            <div className='text-center' style={{ fontSize: '1.5rem' }}>
                                <span className="mt-2 mr-2 storage-icon-container text-muted">{isOpen ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</span>
                            </div>
                        </Row>
                    </Accordion.Toggle>
                </Card.Header>
                {isOpen ? <Accordion.Collapse eventKey={String(index)}>
                    {<Card.Body className='card-grid'>
                        {/* <div className="text-center plan-date">
                            <span className="text-label">Worked :</span>
                            <label className="date-range-with-arrow ">
                                <span className="date-range-start">{moment(data[data.length - 1].worked_day).format('DD MMM YYYY')}</span>
                                <i className="fa fa-long-arrow-right i-arrow" aria-hidden="true"></i>
                                <span className="date-range-end">{moment(data[0].worked_day).format('DD MMM YYYY')}</span>
                            </label>
                        </div> */}
                        <AnalyzeRecentSummaryDetail isAccordOpen={isOpen} propState={propState} data={data} summaryType='year' />
                        {data.map((it, idx) => {
                            return (<AnalayzeRecentSummary key={`${idx} ${year}`} data={it} index={idx} propState={propState} />)
                        })}
                    </Card.Body>}
                </Accordion.Collapse> : null}
            </Card>
        </Accordion>
    )
})